import replace from 'lodash/replace'

export const toElementId = (filePath) =>
  `iac-file-panel-${replace(replace(filePath, /\./g, '---'), /\//g, '--')}`
